<template>
  <v-card class="rounded-lg details-wrapper" flat>
    <v-card-title class="profile-card-title">{{
      $t("userInfo.userInformation")
    }}</v-card-title>
    <v-divider class="mx-4 my-0" />

    <v-card-text class="pa-2">
      <v-row no-gutters>
        <v-col cols="12">
          <label>{{ $t("userInfo.profilePicture") }}</label>
          <br />
          <div class="pa-4 d-flex align-center">
            <div id="kt_profile_avatar" class="image-input image-input-outline">
              <div class="image-input-wrapper rounded">
                <img
                  :src="current_photo"
                  alt=""
                  class="rounded"
                  height="115"
                  width="115"
                />
              </div>
              <label
                class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                data-action="change"
                data-original-title="Change avatar"
                data-toggle="tooltip"
                title=""
              >
                <i
                  class="fa fa-pen icon-sm text-muted"
                  style="color: dodgerblue !important"
                />
                <input
                  accept=".png, .jpg, .jpeg"
                  name="profile_avatar"
                  type="file"
                  @change="onFileChange($event)"
                />
                <input name="profile_avatar_remove" type="hidden" />
              </label>
              <span
                class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                data-action="cancel"
                data-toggle="tooltip"
                title="Cancel avatar"
              >
                <i class="ki ki-bold-close icon-xs text-muted" />
              </span>
              <span
                class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                data-action="remove"
                data-toggle="tooltip"
                :title="$t('userInfo.profilePicture')"
                @click="current_photo = null"
              >
                <i
                  class="ki ki-bold-close icon-xs text-muted"
                  style="color: red !important"
                />
              </span>
            </div>

            <div class="mr-4">
              <span class="form-text text-muted">{{
                $t("userInfo.allowedFileTypes")
              }}</span>
              <span class="form-text text-muted">{{
                $t("userInfo.profilePictureSize")
              }}</span>
              <span class="form-text text-danger">{{
                errors.image ? errors.image[0] : ""
              }}</span>
            </div>
          </div>
        </v-col>

        <v-col class="pa-2" cols="12" md="6">
          <label for="name">{{ $t("userInfo.firstName") }} *</label>
          <v-text-field
            id="name"
            :value="localUser.name"
            append-icon="mdi-account"
            dense
            outlined
            :placeholder="$t('userInfo.firstName')"
            readonly
          />
        </v-col>

        <v-col class="pa-2" cols="12" md="6">
          <label for="name">{{ $t("userInfo.lastName") }} *</label>
          <v-text-field
            id="name"
            :value="localUser.lastName"
            append-icon="mdi-account-supervisor"
            dense
            outlined
            :placeholder="$t('userInfo.lastName')"
            readonly
          />
        </v-col>

        <v-col class="pa-2" cols="12" sm="6">
          <label for="username">{{ $t("userInfo.username") }}</label>
          <v-text-field
            id="username"
            v-model="localUser.username"
            append-icon="mdi-at"
            dense
            outlined
            :placeholder="$t('userInfo.username')"
          />
        </v-col>

        <!-- Commented-out section remains unchanged -->
        <!--
        <v-col class="pa-2" cols="12" md="6">
          <label for="name">تاریخ تولد</label>
          <custom-date-picker :max="max" append-icon="mdi-calendar-month" dense format="date"
                              outlined placeholder="1379/07/04" sp="/"/>
        </v-col>

        <v-col class="pa-2" cols="12" md="6">
          <label for="sex">جنسیت</label>
          <div class="d-flex">
            <v-btn-toggle id="sex" class="justify-space-between w-100" color="primary" dense group mandatory>
              <v-btn class="rounded" min-width="calc(50% - 12px)" value="female">
                <v-icon class="me-3">mdi-face-woman</v-icon>
                خانم
              </v-btn>
              <v-btn class="rounded" min-width="calc(50% - 12px)" value="male">
                <v-icon class="me-3">mdi-face-man</v-icon>
                آقا
              </v-btn>
            </v-btn-toggle>
          </div>
        </v-col>
        -->

        <v-col class="pa-2" cols="12" sm="6">
          <label for="phone">{{ $t("userInfo.phone") }}</label>
          <v-text-field
            id="phone"
            :value="localUser.phone"
            append-icon="mdi-phone"
            dense
            outlined
            readonly
            :placeholder="$t('userInfo.phone')"
          />
        </v-col>

        <v-col class="pa-2" cols="12" sm="6">
          <label for="email">{{ $t("userInfo.email") }}</label>
          <v-text-field
            id="email"
            v-model="localUser.email"
            append-icon="mdi-at"
            dense
            outlined
            :placeholder="$t('userInfo.email')"
          />
        </v-col>

        <v-col class="pa-2" cols="12" md="6">
          <label class="text-right ma-0">{{ $t("userInfo.receiveSMS") }}</label>
          <div class="form-group align-items-center">
            <div>
              <div class="col-3">
                <span class="switch switch-sm switch-icon">
                  <label>
                    <input
                      v-model="notificationStatus"
                      name="select"
                      type="checkbox"
                    />
                    <span></span>
                  </label>
                </span>
              </div>
              <span class="form-text text-dark-50">{{
                $t("userInfo.smsCostNote")
              }}</span>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions class="justify-end pa-4">
      <v-btn
        class="rounded-lg"
        color="primary"
        depressed
        large
        width="120"
        @click="save"
      >
        <v-icon class="me-2">mdi-check</v-icon>
        {{ $t("userInfo.saveChanges") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import i18n from "@/i18n";

export default {
  name: "userInfo",
  i18n,
  data: () => ({
    current_photo: null,
    default_photo: "media/users/blank.webp",
    errors: {},
    image: "",
    localUser: null,
    notificationStatus: false,
  }),

  created() {
    this.localUser = new Object(this.user);

    if (
      this.user &&
      this.user?.image !== null &&
      this.user?.image !== undefined
    ) {
      this.current_photo = `"${this.$coreApi}/storage/"` + this.user?.image;
    } else {
      this.current_photo = "/media/user_avatar.jpeg";
    }
  },

  watch: {
    user(val) {
      this.localUser = val;
    },
  },

  methods: {
    onFileChange(e) {
      if (this.current_photo === this.coreLandApi(this.localUser?.image))
        this.current_photo = null;
      const file = e.target.files[0];
      this.image = file;

      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.current_photo = event.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    save() {
      this.loading = true;
      let formData = new FormData();
      formData.append("username", this.localUser.username);
      if (this.email !== "") formData.append("email", this.localUser.email);
      if (this.image !== null) formData.append("image", this.image);

      formData.append("notification_status", this.notificationStatus);

      this.requestApiPost("edit/user", formData, this.configurationFile())
        .then(({ data }) => {
          this.loading = false;
          this.errors = [];
          this.$store.dispatch("setUser", data.data);
          this.$toast.success(this.$t("userInfo.profileUpdated"));
        })
        .catch(({ response }) => {
          this.loading = false;
          this.errors = response.data.errors;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-card-title {
  position: relative;

  &:before {
    content: "";
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 24px;
    background: dodgerblue;
    border-radius: 8px;
  }
}
</style>
